import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { RouterModule } from '@angular/router';

import { SettingsComponent } from './settings.component';
import { CanAccessSettingsGuard } from './can-access-settings.guard';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    RouterModule,
  ],
  declarations: [
    SettingsComponent
  ],
  providers: [
    CanAccessSettingsGuard
  ],
})
export class SettingsModule { }
